/**
 * @generated SignedSource<<5dc4ab3d782e2cd08b423cb626d68244>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskSellerPopularArticles_viewer$data = {
  readonly getHelpSellerCmsTopics: ReadonlyArray<{
    readonly groupKey: string | null;
    readonly topics: ReadonlyArray<{
      readonly topicKey: string | null;
      readonly topicLabel: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "GetHelpZendeskSellerPopularArticles_viewer";
};
export type GetHelpZendeskSellerPopularArticles_viewer$key = {
  readonly " $data"?: GetHelpZendeskSellerPopularArticles_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskSellerPopularArticles_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isSeller"
    },
    {
      "kind": "RootArgument",
      "name": "orderId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskSellerPopularArticles_viewer",
  "selections": [
    {
      "alias": "getHelpSellerCmsTopics",
      "args": [
        {
          "kind": "Variable",
          "name": "isSeller",
          "variableName": "isSeller"
        },
        {
          "kind": "Variable",
          "name": "orderId",
          "variableName": "orderId"
        }
      ],
      "concreteType": "getHelpCmsTopicGroup",
      "kind": "LinkedField",
      "name": "getHelpCmsTopics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "groupKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "getHelpCmsTopicGroupTopic",
          "kind": "LinkedField",
          "name": "topics",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "topicKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "topicLabel",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b9fbd702d1adb9c6942579f0d936aea0";

export default node;
